import { SelectChangeEvent } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from 'react';
import { useNavigate, } from "react-router-dom";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { RESET_DATE, RESET_SHIFT, SET_DATE, SET_SHIFT, defaultDate, defaultShift } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { CasualAuditReport } from "./CasualAuditReport";

export const CasualAuditReportRoute = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobal();
  const selectedDate = state.dateValue ?? defaultDate;
  const selectedShift = state.shift ?? defaultShift;
  const [dateError, setDateError] = useState<string | null>("");
  const formattedDate = (date: Dayjs | null) => dayjs(date).format('DDMMYYYY');
  const disabledView = !selectedDate || selectedShift === "" || !!dateError;
  const MAIN_ROUTE = '/casual-audit-report';

  useEffect(() => {
    if (!state.previousLocation?.includes(MAIN_ROUTE)) {
      dispatch({ type: RESET_DATE });
      dispatch({ type: RESET_SHIFT });
    }
  }, [dispatch, state.previousLocation]);

  const handleDateChange = (date: Dayjs | null) => {
    dispatch({ type: SET_DATE, payload: date ?? defaultDate });
  };

  const handleShiftChange = (event: SelectChangeEvent<string>) => {
    dispatch({ type: SET_SHIFT, payload: event.target.value });
  };

  const handleSubmit = () => {
    navigate(`${MAIN_ROUTE}-results/${formattedDate(selectedDate)}/${selectedShift}`);
  };

  const datePickerCompProps = {
    title: "Order Date",
    date: selectedDate,
    handleDateChange,
    onError: setDateError,
    error: dateError
  }

  return (
    <CasualAuditReport
      datePickerCompProps={datePickerCompProps}
      dispatchType={selectedShift}
      disabledView={disabledView}
      handleSubmit={handleSubmit}
      handleShiftChange={handleShiftChange}
    />
  )
}